var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolderClosed = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.843,
    height: 16.674,
    viewBox: "0 0 20.843 16.674",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Folder_Closed",
    "data-name": "Folder Closed",
    d: "M22.5,10.605H14.444l-2.33-1.942A2.87,2.87,0,0,0,10.28,8H6.345A2.348,2.348,0,0,0,4,10.345V22.33a2.348,2.348,0,0,0,2.345,2.345H22.5a2.348,2.348,0,0,0,2.345-2.345V12.95A2.348,2.348,0,0,0,22.5,10.605Z",
    transform: "translate(-4 -8)",
    fill: "#8c919a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolderClosed);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/folder-closed.f434585f8c7d81bba12b75a94a2e17a0.svg";